export enum PmrClassification {
  Green,
  Yellow,
  Red,
  Na,
}
